import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DatalayerService } from 'src/services/datalayer.service';
import { HubService } from 'src/services/hub.service';
import { EventsElement } from 'src/services/hub/events.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-events-panel',
  templateUrl: './events-panel.component.html',
  styleUrls: ['./events-panel.component.scss']
})
export class EventsPanelComponent implements OnInit, OnDestroy {

  eventHtml: SafeHtml | null = null;
  private clickListener: any;
  eventsList: EventsElement[] = [];

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private elRef: ElementRef,
    private datalayerService: DatalayerService,
    private hubService: HubService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.loadMockEvent();
    this.attachClickDelegation();

    this.hubService.fetchEvents(this.translateService.currentLang).subscribe(list => {
      this.eventsList = [];
  
      list.forEach(item => {
        if (Array.isArray(item.HubElements)) {
          this.eventsList.push(...item.HubElements);
        } else if (item.HubElements) {
          this.eventsList.push(item.HubElements);
        }
      });
    });
  }

  ngOnDestroy(): void {
    if (this.clickListener) {
      this.elRef.nativeElement.removeEventListener('click', this.clickListener);
    }
  }

  loadMockEvent() {
    this.http.get('assets/test/events-mock-data.html', { responseType: 'text' })
      .subscribe({
        next: data => {
          this.eventHtml = this.sanitizer.bypassSecurityTrustHtml(data);
        },
        error: err => {
          console.error('Failed to load mock event HTML', err);
        }
      });
  }

  private attachClickDelegation(): void {
    this.clickListener = (event: any) => {
      const target = event.target;

      if (target.tagName === 'A') {
        event.preventDefault(); // prevent default navigation

        const link = target.getAttribute('href') ?? '';
        const linkText = target.textContent.trim();

        const card = target.closest('.event-card');
        const titleEl = card?.querySelector('.event-title');
        const eventTitle = titleEl ? titleEl.textContent.trim() : 'Unknown Event';

        this.eventClick(link, linkText, eventTitle);

        if (link && link !== '#') {
          window.open(link, '_blank');
        }
      }
    };

    this.elRef.nativeElement.addEventListener('click', this.clickListener);
  }

  eventClick(link: string, text: string, title: string): void {
    this.datalayerService.eventClick(link, text, title);
  }

  getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}